<template>
<el-card>
    <template v-slot:header>
    <div class="clearfix">
        <span style="font-weight: bold;"><i class="el-icon-tickets" style="font-weight: bold; font-size: larger; margin-right: 5px;"></i>Gene Information</span>
    </div>
    </template>
    <div v-if="Object.keys(geneData).length > 0">
    <table class="table">
        <tbody>
        <tr>
            <td class="th">Symbol</td>
            <td class="td" style="color: brown;">{{ geneData[0].Symbol.charAt(0).toUpperCase() + geneData[0].Symbol.slice(1).toLowerCase() }}</td>
        </tr>
        <tr>
            <td class="th">Chromosome</td>
            <td class="td">{{ geneData[0].Chromosome }}</td>
        </tr>
        <tr>
            <td class="th">Location</td>
            <td class="td">{{ geneData[0].Location }}</td>
        </tr>
        <tr>
            <td class="th">Description</td>
            <td class="td">{{ geneData[0].Description }}</td>
        </tr>
        <tr>
            <td class="th">Type</td>
            <td class="td">{{ geneData[0].Type }}</td>
        </tr>
        <tr>
            <td class="th">Species</td>
            <td class="td">{{ geneData[0].Species }}</td>
        </tr>
        </tbody>
    </table>
    </div>
</el-card>
</template>

<script>
export default {
    props: {
        species: {
        type: String,
        required: true,
        },
        gene: {
        type: String,
        required: true,
        },
    },
    data() {
        return {
        url: "http://183.175.59.4/devenhancer/",
        geneData: [],
        };
    },
    created() {
        // 在组件创建时触发数据获取
        this.fetchGeneData();
    },
    methods: {
        fetchGeneData() {
        const params = {
            Species: this.species,
            Symbol: this.gene,
        };
        // 使用 Axios 或其他 HTTP 客户端库发送请求获取数据
        // 示例使用 Axios
        this.$axios.get(this.url + "Geneinfo" + "/", { params })
            .then(response => {
                this.geneData = response.data;
            })
            .catch(error => {
            console.error('Error fetching gene data:', error);
            });
        },
    },
};
</script>

<style scoped>
.table {
    width: 100%;
    border-collapse: collapse;
}

.th,
.td {
    border-bottom: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Genefig1.vue